<form [formGroup]="form">
  <!-- ... nested form controls ... -->
  <h5 style="text-align: left">{{ "addLP.firstStep.title" | translate }}</h5>
  <div class="form-group" *ngIf="isAdminLoggedIn && isFranchised">
    <div class="form-group" style="margin-top: 12px;">
      <label class="label"
        ><b>{{ "FranchisedOptions.assignFranchises" | translate }}</b></label
      >
      <div class="input-group">
        <select class="form-select form-control" formControlName="franchise">
          <option [ngValue]="null" disabled selected>
            {{ "FranchisedOptions.assignFranchisePlaceholder" | translate }}
          </option>
          <option
            class="form-select"
            *ngFor="let companyName of resultAllFranchisesCompanyNames"
          >
            {{ companyName }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.firstStep.firstName" | translate }} *</label>
    <div class="input-group">
      <input
        formControlName="firstname"
        class="form-control"
        type="text"
        required
        [placeholder]="'profile.profileDetails.firstName' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('firstname')?.valid && form.get('firstname')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="!form.get('firstname')?.valid && form.get('firstname')?.touched"
      >
        {{ "validation.firstName" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.firstStep.lastName" | translate }} *</label>
    <div class="input-group">
      <input
        formControlName="lastname"
        class="form-control"
        type="text"
        required
        [placeholder]="'profile.profileDetails.lastName' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('lastname')?.valid && form.get('lastname')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="!form.get('lastname')?.valid && form.get('lastname')?.touched"
      >
        {{ "validation.lastName" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.firstStep.email" | translate }} *</label>
    <div class="input-group">
      <input
        formControlName="email"
        class="form-control"
        type="email"
        appNoSpaces
        appIgnorePasswordManagers
        required
        [placeholder]="'profile.profileDetails.email' | translate"
        [ngClass]="{
          'is-invalid': !form.get('email')?.valid && form.get('email')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="!form.get('email')?.valid && form.get('email')?.touched"
      >
        {{ "validation.email" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.firstStep.password" | translate }} *</label>
    <div class="input-group">
      <input
        formControlName="password"
        class="form-control"
        [type]="showPassword1 ? 'text' : 'password'"
        appIgnorePasswordManagers
        required=""
        placeholder="*********"
        [ngClass]="{
          'is-invalid':
            !form.get('password')?.valid && form.get('password')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="!form.get('password')?.valid && form.get('password')?.touched"
      >
        {{ "errorMsg.validPassword" | translate }}
        <ul style="padding-left: 10px">
          <li>- {{ "password.pattern.validator1" | translate }}</li>
          <li>- {{ "password.pattern.validator2" | translate }}</li>
          <li>- {{ "password.pattern.validator3" | translate }}</li>
        </ul>
      </div>
      <div
        class="show-hide"
        (click)="showPassword()"
        *ngIf="!showPassword1"
        onKeyPress
      >
        <span> {{ "password.show" | translate }} </span>
      </div>
      <div
        class="show-hide"
        (click)="showPassword()"
        *ngIf="showPassword1"
        onKeyPress
      >
        <span>{{ "password.cash" | translate }}</span>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.firstStep.confirmPassword" | translate }} *</label
    >
    <div class="input-group">
      <input
        formControlName="confirmPassword"
        class="form-control"
        [type]="showConfirmPassword1 ? 'text' : 'password'"
        appIgnorePasswordManagers
        required=""
        placeholder="*********"
        [ngClass]="{
          'is-invalid':
            !form.get('confirmPassword')?.valid &&
            form.get('confirmPassword')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('confirmPassword')?.valid &&
          form.get('confirmPassword')?.touched
        "
      >
        <div style="padding-left: 10px">
          {{ "password.matchPassword" | translate }}
        </div>
      </div>
      <div
        class="show-hide"
        (click)="showConfirmPassword()"
        onKeyPress
        *ngIf="!showConfirmPassword1"
      >
        <span> {{ "password.show" | translate }} </span>
      </div>
      <div
        class="show-hide"
        (click)="showConfirmPassword()"
        onKeyPress
        *ngIf="showConfirmPassword1"
      >
        <span>{{ "password.cash" | translate }}</span>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.secondStep.companyPhone" | translate }} *</label
    >
    <div class="input-group">
      <input
        formControlName="phone"
        class="form-control m-input digits"
        type="text"
        [mask]="'99 999 999'"
        required
        [placeholder]="'addLP.secondStep.companyPhone' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('phone')?.valid &&
            form.get('phone')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('phone')?.valid && form.get('phone')?.touched
        "
      >
        {{ "validation.phone" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.secondStep.role" | translate }} *</label>
    <div class="input-group">
      <input
        class="form-control"
        type="text"
        formControlName="companyRole"
        required
        [placeholder]="'addLP.secondStep.role' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('companyRole')?.valid && form.get('companyRole')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('companyRole')?.valid && form.get('companyRole')?.touched
        "
      >
        {{ "validation.companyRole" | translate }}
      </div>
    </div>
  </div>
</form>
